import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "../styles/Workplace.css";

const Workplace = () => {
  return (
    <>
      {/* Full-width heading */}
      <h2 id="Workplace" className="text-center bg-dark text-light my-4 py-4 w-100">
        Our Workforce and Workplace
      </h2>
    <section className="Workplace-section py-5">
      <Container>
        <Row className="align-items-center">
        
          {/* Right Side (Image) */}
          <Col lg={6} className="image-content">
            <img src="/workforce.jpeg" alt="Our Workplace" className="img-fluid Workplace-image" />
          </Col>
          {/* Left Side (Heading & Text) */}
          <Col lg={6} className="text-content">
            <h2 className="Workplace-heading">Our WorkForce:Driving Excellence with Passion</h2>
            <p className="Workplace-text">
            At Bhanot International LLC, our workforce is our greatest asset. We take pride in our team of skilled professionals who bring innovation, dedication, and expertise to every task. Our employees work collaboratively, leveraging their experience to deliver top-quality solutions. We foster an environment that encourages growth, continuous learning, and adaptability, ensuring that our workforce remains at the forefront of industry advancements.
            </p>
          </Col>
        </Row>
        <Row className="align-items-center">

          {/* Left Side (Heading & Text) */}
          <Col lg={6} className="text-content">
            <h2 className="Workplace-heading">Our Workplace: A Hub of Innovation and Collaboration</h2>
            <p className="Workplace-text">
            At Bhanot International LLC, our workplace is more than just a physical space—it’s an ecosystem that nurtures creativity, efficiency, and collaboration. Designed to inspire innovation, our work environment is equipped with modern infrastructure, advanced technology, and a supportive culture that enhances productivity.
            We believe that a positive workplace fosters motivated employees. That’s why we provide state-of-the-art facilities, ergonomic workspaces, and a dynamic setting where employees can thrive. Whether in our production units, research labs, or corporate offices, we ensure that every member of our team has the tools and support needed to excel.
            </p>
          </Col>
                  
          {/* Right Side (Image) */}
          <Col lg={6} className="image-content">
            <img src="/workolace.png" alt="Our Workplace" className="img-fluid Workplace-image" />
          </Col>
        </Row>
      </Container>
    </section>
    </>
  );
};

export default Workplace;
